import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-gmt-message',
  templateUrl: './gmt-message.component.html',
  styleUrls: ['./gmt-message.component.scss'],
})
export class GmtMessageComponent implements OnInit {
  public difference: number;

  constructor(
    public paramSv: ParamServicesService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    const timezone1 = +this.getCurrentGMTOffset();
    const timezone2 = +this.paramSv.meeting.gmtZone.split(':')[0];

    this.difference = this.calculateTimeDifference(timezone1, timezone2);
  }

  close() {
    this.modalController.dismiss();
  }

  calculateTimeDifference(timezone1, timezone2) {
    const difference = timezone1 - timezone2;
    return difference;
  }

  getCurrentGMTOffset() {
    const now = new Date();
    const offset = -now.getTimezoneOffset() / 60;
    const sign = offset >= 0 ? '+' : '-';
    return `${sign}${Math.abs(offset)}`;
  }
}
